import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getEmployments } from '../../../../../global/ducks/benadmin-api';
import { TcsmStates } from '../../../../../root/tcsm-model';
import { GetEmploymentsAndCompensations } from '../../employment-compensation/employment-compensation-requests';



export function useCompensationState() {
	const dispatch = useDispatch();
	const guid = useSelector<TcsmStates, string>(state => state.employmentState?.currentEmployee?.guid);
	const loaded = useSelector<TcsmStates, boolean>(state => state.employmentCompensationState?.employmentCompensationLoaded);

	useEffect(() => {
		if (guid && !loaded) {
			dispatch(getEmployments(
				guid,
				(response) => GetEmploymentsAndCompensations(dispatch, response),
			));
		}
	}, [guid]);

	return loaded;
}